/**
 * Read a `File`'s raw bytes, preferring `Blob.arrayBuffer` with a
 * `FileReader` fallback (cue-forge-sdv.11.6 final-review cleanup — the single
 * implementation `SessionContext.tsx` and the transcribe dialog's
 * `readFile.ts` both used to hand-roll identically). jsdom's `File` has no
 * `arrayBuffer()`, so the fallback also covers that test environment, as well
 * as any real browser missing the method.
 */
export async function readFileBytes(file: File): Promise<Uint8Array> {
  if (typeof file.arrayBuffer === 'function') {
    return new Uint8Array(await file.arrayBuffer());
  }
  return new Promise<Uint8Array>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(new Uint8Array(reader.result as ArrayBuffer));
    reader.onerror = () => reject(reader.error ?? new Error('File read failed'));
    reader.readAsArrayBuffer(file);
  });
}
